import React from 'react';
import { FuelTypography, FuelLoading } from '@frete.com/fuel-react';
import { LoadingPropsInterface } from './LoadingTypes';
import * as Styled from './LoadingStyles';

function Loading({ isShow }: LoadingPropsInterface) {
  if (!isShow) {
    return null;
  }

  return (
    <Styled.Wrapper>
      <div>
        <FuelLoading size="huge" />
        <FuelTypography size="body-sm" weight="bold">
          Carregando informações
        </FuelTypography>
      </div>
    </Styled.Wrapper>
  );
}

export default Loading;
